import { useApiDataService } from './use-api-data-service';
import { OrgService } from 'services/org-service';

export const useOrgService = () => useApiDataService<OrgService>(OrgService);
export default useOrgService;
